import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ShoppingCartFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M7.41105 4.3877H3.375V6.1127H6.10352L6.49382 7.50342H6.47998L7.70512 11.8196L8.96136 16.2959C8.34744 16.5314 7.91162 17.1264 7.91162 17.8231C7.91162 18.7262 8.6437 19.4583 9.54678 19.4583C10.351 19.4583 11.0197 18.8777 11.1564 18.1127H16.3659C16.5026 18.8777 17.1712 19.4583 17.9755 19.4583C18.8786 19.4583 19.6106 18.7262 19.6106 17.8231C19.6106 16.9201 18.8786 16.188 17.9755 16.188C17.6915 16.188 17.4245 16.2604 17.1918 16.3877H10.7788L10.1839 14.268H18.37L20.6248 7.50342H8.28546L7.41105 4.3877Z"
      />
    </SvgIcon>
  );
});
